import { createStitches, defaultThemeMap } from "@stitches/react";

export const { config, styled, css, globalCss, keyframes, getCssText, theme, createTheme } = createStitches({
  themeMap: {
    ...defaultThemeMap,
    height: "space",
    width: "space",
    maxWidth: "space",
    maxHeight: "space",
    minWidth: "space",
    minHeight: "space",
    backgroundSize: "space",
    gridTemplateColumns: "space",
  },

  theme: {
    colors: {
      white: "#FFFFFF",
      black: "#000000",

      yellow10: "#FEF8EF",
      yellow20: "#F7EDD9",
      yellow30: "#FAA819",
      yellow40: "#DA810B",
      yellow60: "#A56109",
      yellow70: "#693B07",
      yellow80: "#3A230D",

      green10: "#EDFDF5",
      green20: "#C3EFD6",
      green30: "#21BA78",
      green40: "#27825C",
      green60: "#0E4E32",
      green70: "#083021",
      green80: "#051A0F",

      red10: "#FBEFEF",
      red20: "#F8DDE5",
      red30: "#E689A0",
      red40: "#DA2B59",
      red60: "#861934",
      red70: "#530E20",
      red80: "#2A090E",

      blue00: "#EAF4FF",
      blue10: "#D1E7FF",
      blue20: "#B2D6FF",
      blue30: "#147DF5",
      blue40: "#0152F8",
      blue50: "#147DF5",
      blue60: "#0152F8",
      blue70: "#084387",
      blue80: "#052B57",
      blue90: "#021327",

      gray50: "#7C8183",

      orange20: "#FEF8EF",
      orange40: "#FAA819",

      purple20: "#F6EDFC",
      purple40: "#B873DE",
      purple60: "#7D21C0",

      pink25: "#FEF6FB",
      pink200: "#FCCEEE",
      pink500: "#EE46BC",

      neutral00: "#FFFFFF",
      neutral05: "#FAFAFA",
      neutral10: "#FAFAFB",
      neutral20: "#E6E8EB",
      neutral30: "#D2D4D7",
      neutral40: "#AEB0B5",
      neutral50: "#707881",
      neutral60: "#525860",
      neutral70: "#3E4349",
      neutral80: "#292C30",
      neutral90: "#1f1f1f",
      neutral100: "#1F1F1F",

      skeletonpreviewbglight: "linear-gradient(90deg, rgba(222,225,228,1) 0%, rgba(255,255,255,0) 100%)",

      skeletonpreviewbgdark: "linear-gradient(90deg, #303030 0%, #000000 99.99%, rgba(201, 201, 201, 0.85) 100%)",

      fadetoleft: "linear-gradient(270deg, rgba(255,255,255,1), rgba(255,255,255,0))",

      fadetoright: "linear-gradient(270deg, rgba(255,255,255,0), rgba(255,255,255,1))",

      fadetorightDarkTheme: "linear-gradient(90deg, #303030 0%, #000000 99.99%, rgba(201, 201, 201, 0.85) 100%)",

      "content-1": "rgba(25, 53, 107, 1)",
      "content-2": "rgba(25, 53, 107, 0.6)",
      "content-3": "rgba(25, 53, 107, 0.3)",

      "background-inverse-1": "#1F1F1F",
      "background-1": "rgba(255, 255, 255, 1)",
      "background-2": "rgba(12, 26, 123, 0.15)",
      "background-3": "rgba(12, 26, 123, 0.05)",
      "background-4": "rgba(255, 245, 245, 1)",

      "background-blue": "#3ACAF8",

      danger50: "#FBEFEF",
      dangerRed: "#DA2B59",

      primary50: "#F5FAFF",
      primary300: "#0152F8",
    },

    space: {
      "1px": "0.063rem",
      "2px": "0.125rem",
      "3px": "0.1875rem",
      "4px": "0.25rem",
      "5px": "0.313rem",
      "6px": "0.375rem",
      "8px": "0.5rem",
      "10px": "0.625rem",
      "12px": "0.75rem",
      "13px": "0.8125rem",
      "14px": "0.875rem",
      "15px": "0.938rem",
      "16px": "1rem",
      "18px": "1.125rem",
      "20px": "1.25rem",
      "22px": "1.375rem",
      "24px": "1.5rem",
      "25px": "1.5625rem",
      "28px": "1.75rem",
      "30px": "1.875rem",
      "32px": "2rem",
      "36px": "2.25rem",
      "38px": "2.375rem",
      "40px": "2.5rem",
      "44px": "2.75rem",
      "46px": "2.875rem",
      "48px": "3rem",
      "50px": "3.125rem",
      "52px": "3.25rem",
      "54px": "3.375rem",
      "56px": "3.5rem",
      "60px": "3.75rem",
      "64px": "4rem",
      "70px": "4.375rem",
      "72px": "4.5rem",
      "80px": "5rem",
      "88px": "5.5rem",
      "90px": "5.625rem",
      "95px": "5.938rem",
      "100px": "6.25rem",
      "110px": "6.875rem",
      "115px": "7.188rem",
      "116px": "7.25rem",
      "120px": "7.5rem",
      "128px": "8rem",
      "140px": "8.75rem",
      "148px": "9.25rem",
      "150px": "9.375rem",
      "160px": "10rem",
      "170px": "10.625rem",
      "180px": "11.25rem",
      "184px": "11.5rem",
      "190px": "11.875rem",
      "200px": "12.5rem",
      "210px": "13.125rem",
      "216px": "13.5rem",
      "218px": "13.625rem",
      "220px": "13.75rem",
      "224px": "14rem",
      "235px": "14.688rem",
      "240px": "15rem",
      "268px": "16.875rem",
      "280px": "17.5rem",
      "300px": "18.75rem",
      "340px": "21.25rem",
      "345px": "21.563rem",
      "350px": "21.875rem",
      "400px": "25rem",
      "450px": "28.125rem",
      "500px": "31.25rem",
      "520px": "32.5rem",
      "600px": "37.5rem",
      "768px": "48rem",
      "1042px": "65.125rem",
      "1150px": "71.875rem",
      "1275px": "79.688rem",
    },

    radii: {
      px: "1px",
      xsm: "2px",
      sm: "4px",
      xmd: "6px",
      md: "8px",
      xlg: "12px",
      lg: "16px",
      rounded: "999px",
    },

    fonts: {
      inter: "Inter, sans-serif",
      "satoshi-bold": "Satoshi-Bold, sans-serif",
      "satoshi-medium": "Satoshi-Medium, sans-serif",
      "satoshi-regular": "Satoshi-Regular, sans-serif",
      "satoshi-light": "Satoshi-Light, sans-serif",
      code: "monospace",
    },

    fontWeights: {
      light: "300",
      regular: "400",
      medium: "500",
      semibold: "600",
      bold: "700",

      sm: "400",
      md: "500",
      xl: "600",
      lg: "700",
      xlg: "900",
    },
    fontSizes: {
      xxs: "0.625rem", // 10px
      xs: "0.75rem", // 12px
      sm: "0.875rem", // 14px
      md: "1rem", // 16px
      lg: "1.125rem", // 18px
      xl: "1.25rem", // 20px

      "4px": "0.25rem",
      "8px": "0.5rem",
      "10px": "0.625rem",
      "12px": "0.75rem",
      "14px": "0.875rem",
      "16px": "1rem",
      "18px": "1.125rem",
      "20px": "1.25rem",
      "24px": "1.5rem",
      "32px": "2rem",
      "40px": "2.5rem",
      "48px": "3rem",
      "64px": "4rem",
    },
    lineHeights: {
      shorter: "125%",
      short: "140%",
      base: "160%",
      tall: "180%",
      taller: "195%",

      "8px": "0.5rem",
      "12px": "0.75rem",
      "16px": "1rem",
      "18px": "1.125rem",
      "24px": "1.5rem",
      "32px": "2rem",
      "40px": "2.5rem",
      "48px": "3rem",
    },
    sizes: {
      "space-1": "0.5rem",
      "space-2": "1rem",
      "space-3": "2rem",
      "space-4": "3rem",
      "space-5": "17.5rem",
    },
    letterSpacings: {},
    borderStyles: {},
    shadows: {
      s: "0px 2px 4px rgba(0, 0, 0, 0.15)",
      m: "0px 2px 8px rgba(0, 0, 0, 0.15)",
      md: "0px 0px 32px rgba(50, 50, 50, 0.15)",
      l: "0px 0px 64px rgba(50, 50, 50, 0.2)",
      xl: "0px 0px 128px 16px rgba(50, 50, 50, 0.3)",
      xxl: "0px 10px 20px rgba(0, 0, 0, 0.1)",
      info: "0px 0px 8px rgba(58, 202, 248, 0.2)",
      light: "0px 0px 16px rgba(227, 227, 227, 0.8)",
      dark: "0px 0px 16px rgba(23, 23, 23, 0.8)",
      blue10: "#021327",
    },
    zIndices: {},
    transitions: {
      fast: "0.3s",
      normal: "0.7s",
      long: "1s",
    },
  },

  media: {
    xs: "(max-width: 360px)",
    xsm: "(max-width: 412px)",
    sm: "(max-width: 576px)",
    smm: "(min-width: 577px)",
    md: "(max-width: 768px)",
    mdh: "(max-height: 768px)",
    lg: "(max-width: 992px)",
    xl: "(max-width: 1200px)",
    xxlg: "(max-width: 1440px)",
    xxxl: "(max-width: 1600px)",
    xxxlg: "(max-width: 1740px)",
    xxl: "(min-width: 1400px)",

    "h-sm": "(max-height: 720px)",
    "h-md": "(max-height: 820px)",
  },
});

export const darkTheme = createTheme("dark", {
  colors: {
    // yellow80: "#FEF8F4",
    // yellow70: "#F9EFD3",
    // yellow60: "#F2DEA6",
    yellow40: "#E69305",
    // yellow30: "#CEA136",
    yellow20: "#A56109",
    yellow10: "#3A230D",

    // green80: "#F6FFF8",
    // green70: "#DCF4E1",
    // green60: "#AAE3B2",
    green40: "#1A9361",
    // green30: "#489D52",
    green20: "#0E4E32",
    green10: "#051A0F",

    // red80: "#FDF5F6",
    // red70: "#F9D8D9",
    // red60: "#EF8889",
    red40: "#DA2B59",
    // red30: "#C32820",
    red20: "#530E20",
    red10: "#2A090E",

    // blue90: "#DBDDEA",
    // blue80: "#D2EAFD",
    blue70: "#D1E7FF",
    blue60: "#B2D6FF",
    blue50: "#57A5FF",
    blue40: "#3390FA",
    // blue30: "#33547D",
    blue20: "#084387",
    blue10: "#052B57",
    blue00: "#021327",

    gray50: "#A8B0B3",

    orange40: "#FAA819",
    orange20: "#3A230D",

    purple60: "#B873DE",
    purple40: "#7D21C0",
    purple20: "#230637",

    pink25: "#4E0D30", //bg
    pink500: "#F670C7", // texto
    pink200: "#C11574", //borda

    neutral00: "#1f1f1f",
    neutral05: "#1F2124",
    neutral10: "#292C30",
    neutral20: "#3E4349",
    neutral30: "#525860",
    neutral40: "#707881",
    neutral50: "#AEB0B5",
    neutral60: "#D2D4D7",
    neutral70: "#E6E8EB",
    neutral80: "#F1F2F4",
    neutral90: "#FAFAFB",
    neutral100: "#FFFFFF",

    danger50: "#2A090E",
    dangerRed: "#E689A0",

    primary50: "#021327",
    primary300: "#0D6EDE",

    fadetoleft: "linear-gradient(85deg, rgba(225, 225, 225, 0), #171717)",

    fadetoright: "linear-gradient(90deg, rgba(24, 24, 24, 1) 50%, rgba(0,0,0,0) 100%)",
  },
});
